import type { WidgetSurface } from "./widgetLayout.js";

// PG-57: the athlete's own Progress, the second widget surface
// (widgetLayout.ts, twin of homeLayout.ts). Antenore 28/09: the two top
// widgets open, the important and useful ones collapsed, the nice-to-have
// ones off. The period selector is the page header, not a widget.

/** Every Progress widget, in the default order. */
export const PROGRESS_WIDGET_IDS = [
  "coverage",
  "e1rmTrends",
  // #389: the exercises the athlete follows. Shown, closed by default.
  "exerciseTracker",
  "repsAtLoad",
  // #124: the reps in reserve at the same load, week by week.
  "rirAtLoad",
  "movementBalance",
  "painVolume",
  "rhythm",
  // Off by default (PROGRESS_DEFAULT_HIDDEN_WIDGETS).
  "tagVolume",
  "intensityHeatmap",
  "exerciseFrequency",
  // PG-59: nice-to-have, off by default (measurement-contract.md §PG-57).
  "prTimeline",
  "weekStreak",
] as const;
export type ProgressWidgetId = (typeof PROGRESS_WIDGET_IDS)[number];

export const PROGRESS_DEFAULT_HIDDEN_WIDGETS: readonly ProgressWidgetId[] = [
  "tagVolume",
  "intensityHeatmap",
  "exerciseFrequency",
  "prTimeline",
  "weekStreak",
];

export const PROGRESS_LAYOUT_SURFACE: WidgetSurface<ProgressWidgetId> = {
  ids: PROGRESS_WIDGET_IDS,
  pinned: [],
  unhideable: [],
  defaultHidden: PROGRESS_DEFAULT_HIDDEN_WIDGETS,
  // Everything but the two top widgets starts closed, the ones that start
  // off included, so turning one on does not push the page down.
  defaultCollapsed: PROGRESS_WIDGET_IDS.filter(
    (id) => id !== "coverage" && id !== "e1rmTrends",
  ),
};
